import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Spinner, Text } from '@chakra-ui/react';
import { ArrowForwardIcon, CheckIcon, ArrowBackIcon } from '@chakra-ui/icons';
import Heading from '../../../../components/v4/Heading';
import Button from '../../../../components/v4/Button';
import Alert from '../../../../components/v4/Alert';
import AlertIcon from '../../../../components/v4/AlertIcon';

const Step = ({ label, check }) => (
    <Box display="flex" alignItems="center" gap={3} py={1}>
        {check ? (
            <Box
                w={5}
                h={5}
                borderRadius="full"
                bg="green.500"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexShrink={0}>
                <CheckIcon color="white" boxSize={2.5} />
            </Box>
        ) : (
            <Spinner size="sm" color="blue.500" flexShrink={0} />
        )}
        <Text
            fontSize="sm"
            color={check ? 'green.600' : 'gray.700'}
            fontWeight={check ? 'normal' : 'medium'}>
            {label}
        </Text>
    </Box>
);

export default function VerifyCSVView(props) {
    const {
        verificationChecks,
        handleViewVerificationResults,
        errors,
        handleStartOver,
    } = props;
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <Box display="flex" justifyContent="start" width="100%">
            <Box
                width="100%"
                maxWidth="700px"
                display="flex"
                flexDirection="column"
                gap="0"
                fontFamily="Inter"
                boxShadow="base"
                p="8"
                bg={darkMode ? 'dark.tcap' : 'white'}
                rounded="md">
                <Heading size="xl" mb={4}>
                    Validation status
                </Heading>

                {errors ? (
                    <React.Fragment>
                        <Alert status="error" mb={4}>
                            <AlertIcon />
                            <Text size="sm" whiteSpace="pre-line">
                                {errors}
                            </Text>
                        </Alert>
                        <Box display="flex" justifyContent="left" mt={2}>
                            <Button
                                leftIcon={<ArrowBackIcon />}
                                size="sm"
                                onClick={handleStartOver}>
                                Start Over
                            </Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Box
                            display="flex"
                            flexDirection="column"
                            gap={1}
                            mt={2}
                            p={4}
                            bg={darkMode ? 'gray.700' : 'gray.50'}
                            borderRadius="md"
                            border="1px solid"
                            borderColor={darkMode ? 'gray.600' : 'gray.200'}>
                            {verificationChecks.map((v, i) => (
                                <Step key={i} label={v.label} check={v.check} />
                            ))}
                        </Box>

                        {verificationChecks.every((v) => v.check) && (
                            <Box display="flex" justifyContent="right" mt={5}>
                                <Button
                                    rightIcon={<ArrowForwardIcon />}
                                    size="sm"
                                    onClick={handleViewVerificationResults}>
                                    View Results
                                </Button>
                            </Box>
                        )}
                    </React.Fragment>
                )}
            </Box>
        </Box>
    );
}
